module.exports = __webpack_public_path__ + "b4c8d9cef7e3ab3c06010223732912eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-emd.png
// module id = 610
// module chunks = 0